import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import CouponPaymentSchedule from "./CouponPaymentSchedule";
import ShowYTMModal from "./ShowYTMModal";
import { chooseTheme } from "../../constants/themeColor";

export default function InvestmentOverviewBase(props) {
  const [showFAQ, setShowFAQ] = useState(false);
  const [showYTM, setShowYTM] = useState(false);
  const [showAssetTable, setShowAssetTable] = useState(false);
  const [isCurrentYield, setCurrentYield] = useState(false);
  const {Coupons} = props;
  const {realisedCouponsSum} = props;
  const [currYield, setCurrYield] = useState(false);

  const card = {
    textAlign: "left",
    color: "black",
    background: "white",
    padding: "1.5rem",
    borderRadius: "8px",
    border: "1px solid #D2D2D2",
    minWidth: "200px",
    marginLeft: '.5rem',
    minHeight: "125px",
    maxHeight: "125px"
  };
  const CouponsCard = {
    textAlign: "left",
    color: "black",
    background: "white",
    padding: "1rem 1.5rem",
    borderRadius: "8px",
    border: "1px solid #D2D2D2",
    minWidth: "200px",
    marginLeft: '.5rem',
    minHeight: "125px",
    maxHeight: "125px"
  };
  const cardTotal = {
    textAlign: "left",
    color: "white",
    background: chooseTheme().secondary,
    padding: "1.5rem",
    borderRadius: "8px",
    minWidth: "200px",
    minHeight: "125px",
    maxHeight: "125px"
  };
  const value = {
    fontSize: "28px",
  };
  const lastCard = {
    textAlign: "left",
    color:"black",
    padding: "1.5rem",
    borderRadius: "8px",
    minWidth: "200px",
    border: "1px solid #D2D2D2",
    marginLeft: '.5rem',
    minHeight: "125px",
    maxHeight: "125px"
  };

  const closeFAQModal = () =>{
    setShowFAQ(!showFAQ);
  };

  const toggleAssetTable = () => {
    setShowAssetTable(!showAssetTable);
  };

  const openModal = () => {
    props.setShowYTM(true)
    setCurrYield(true);
  }

  const redirectToLiquidate = (product, productType) => {
    window.location.href = `/platform/#/biddeasy-asset/${productType}/${product}/redeem`;
  }

  return (
    <>
    <div
      style={props.isTotal ? cardTotal : props.title ==='XIRR' ?
        lastCard : props.title ==='Payouts' || props.title ==='Units' ? CouponsCard : card}
      className="d-flex flex-column align-items-start justify-content-center"
    >
      <p
        style={{ fontSize: "16px" }}
        className={"mb-2 " + (props.last ? "text-dark" : "")}
      >
        {props.title} {props.title==='Current Value'
                            ? <span onClick={()=> setShowFAQ(true)} 
                                    style={{cursor:"pointer",
                                            fontSize: "15px"
                                          }} 
                                    className="mdi mdi-information-outline ml-1" 
                              />
                            : null
                      }
      </p>
      <p className="font-weight-semi-bold m-0" style={value}>
        { props.title==='Payouts' ? realisedCouponsSum ? (realisedCouponsSum).oroNumber(2, true) : "₹ 0" : props.value }
      </p>
      {/* {
        (props.title==="Units" && props.isRedemptionAllowed) &&
        <p
          style={{
            cursor: 'pointer',
            fontSize: "12px",
            marginBottom: '0',
            color:"#283A97",
            textDecoration: 'underline',
            fontWeight: "600"
          }}
          onClick={() => redirectToLiquidate(props?.productName, props?.productType)}
        >
          Liquidate Now
        </p>
      } */}
      {props.title==='Payouts' &&
        <p
            style={{cursor: 'pointer',
                    textAlign: 'right',
                    fontSize: "12px",
                    marginBottom: '0',
                    color:"#283A97",
                    textDecoration: 'underline',
                    fontWeight: "600"
                  }}
            onClick={toggleAssetTable}
        >
          Show More
        </p>
      }
    </div>

    <CouponPaymentSchedule
      showAssetTable={showAssetTable}
      toggleAssetTable={toggleAssetTable}
      realisedCouponsSum={realisedCouponsSum}
      Coupons={Coupons}
    />

      <Modal
        centered
        isOpen={showFAQ}
        toggle={closeFAQModal}
        className="modal-md"
      >
        <ModalHeader toggle={closeFAQModal} className="pt-3 mt-4"></ModalHeader>
        <ModalBody className="text-center p-3">
          <div className="mt-2 mb-4" style={{ textAlign: "left" }}>
            <b className="font-size-12">
            Current Value is the multiplication of per unit current price of asset 
            (dirty price) and number of units held by investors.  
            </b>
          </div>
          {/* <Button className="mt-4 done-button mb-4" onClick={closeFAQModal}>
            Close
          </Button> */}
        </ModalBody>
      </Modal>
      {
        props.showYTM &&
        <ShowYTMModal
          closeYTMModal={props.closeYTMModal}
          showYTM={props.showYTM}
          currentYeild={props?.assetDetails?.xirr}
          currYield={props.currYield}
        />
      }
    </>
  );
}
